import Privacy from '@wetransfer/transfer/modules/privacy';

export const init = ({ cookieDomain, userId, onAcceptTrackers }) => {
  Privacy.configure({ domain: cookieDomain, userId, onAcceptTrackers });
};
